import { Box, Text, HStack, Flex, AspectRatio } from '@chakra-ui/react'
import Image from 'next/image'
import Link from 'next/link'
import BenefitMobile from './benefit-mobie'

const ProductCard08 = () => {
  const productData = {
    titleJP: '平衡血糖、清热解毒',
    titleEN: 'Balance blood sugar, clear heat and detoxify',
    subTitle: '支持血糖平衡 / Support blood sugar balance',
    descJP: `苦瓜三清素是一种高效的天然健康保健品，采用源自日本高知县的纯苦瓜。经过多重精心处理，该补充剂支持体内废物的排除，促进整体健康。苦瓜富含苦瓜皂苷，有助于降低血压、血糖和胆固醇水平。此外，它还能活血、清热和解毒，帮助净化体内废物和毒素，同时调节身体功能。`,
    descEN:
      'Bitter Melon Triple Cleanse is a highly effective natural health supplement featuring pure bitter melon sourced from Kochi Prefecture, Japan. Carefully processed through multiple steps, this supplement supports the elimination of internal waste and promotes overall well-being. Rich in bitter melon saponins, it helps lower blood pressure, blood sugar, and cholesterol levels. Additionally, it invigorates blood circulation, clears heat, and detoxifies, aiding in the purification of internal waste and toxins while regulating bodily functions.',
    imageUrl:
      'https://habbit-sg.s3.ap-southeast-1.amazonaws.com/item-8-1734075592410.png'
  }

  const benefitData = [
    {
      ratio: 578 / 672,
      imageUrl:
        'https://habbit-sg.s3.ap-southeast-1.amazonaws.com/item8-1731603449806.png'
    }
  ]

  return (
    <Flex
      flexDir={{
        base: 'column-reverse',
        lg: 'row'
      }}
      justifyContent="space-between"
      pt={{
        base: '20px',
        lg: '105px'
      }}
      pb="80px"
      gap={5}
      id="bitter-melon"
    >
      <Box
        w={{
          base: '100%',
          lg: '60%'
        }}
      >
        {/* Title and Subtitle */}
        <Box
          w="100%"
          maxW={{
            base: '100%',
            lg: '650px'
          }}
        >
          <Text textStyle="supplementProductCardTitleJP">
            {productData.titleJP}
          </Text>

          <Text textStyle="supplementProductCardTitleEN" mt={1}>
            {productData.titleEN}
          </Text>

          <Text
            textStyle="supplementProductCardSubTitle"
            bg="#9cb25a"
            w={{
              base: 'auto',
              md: 'max-content'
            }}
            mt={5}
            color="white"
            px={2}
            py={1}
          >
            {productData.subTitle}
          </Text>

          <Text textStyle="supplementProductCardDescJP" mt={5}>
            {productData.descJP}
          </Text>

          <Text textStyle="supplementProductCardDescEN" mt={5}>
            {productData.descEN}
          </Text>
        </Box>

        {/* Benefits */}
        <Box w="100%" mt={5}>
          <AspectRatio
            ratio={1552 / 232}
            w="100%"
            display={{
              base: 'none',
              md: 'block'
            }}
          >
            <Image
              src={
                'https://habbit-sg.s3.ap-southeast-1.amazonaws.com/be-8-1731438361792.png'
              }
              alt="traditional item"
              fill
            />
          </AspectRatio>
          <Box
            display={{
              base: 'block',
              md: 'none'
            }}
          >
            <BenefitMobile items={benefitData} isOne />
          </Box>
        </Box>

        {/* Buy Button */}
        <HStack
          justifyContent={{
            base: 'flex-start',
            md: 'flex-start'
          }}
          alignItems="center"
          gap={4}
          mt={5}
        >
          <Link href="https://habbit.sg/products/health-plus-kampo-bitter-melon-triple-cleanse-90s">
            <AspectRatio
              ratio={1537 / 864}
              w={{
                base: '120px',
                sm: '120px',
                md: '140px',
                lg: '160px',
                xl: '160px'
              }}
              _hover={{
                opacity: 0.7
              }}
              mt={3}
            >
              <Image
                src={
                  'https://habbit-sg.s3.ap-southeast-1.amazonaws.com/buy-now-btn-1714038035225.png'
                }
                alt="buy now btn"
                fill
              />
            </AspectRatio>
          </Link>

          <Box
            w={{
              base: '244px',
              xl: '244px'
            }}
            mt={2}
          >
            <AspectRatio ratio={123 / 36} w="100%">
              <Image
                src={
                  'https://habbit-sg.s3.ap-southeast-1.amazonaws.com/item1-certificate-1730969831994.png'
                }
                alt="traditional item"
                fill
              />
            </AspectRatio>
          </Box>
        </HStack>
      </Box>

      <Box
        w={{
          base: '95%',
          lg: '42%'
        }}
        ml={{
          base: '0'
        }}
      >
        <AspectRatio ratio={940 / 1424} w="100%">
          <Image src={productData.imageUrl} alt={productData.titleEN} fill />
        </AspectRatio>
      </Box>
    </Flex>
  )
}

export default ProductCard08
